// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LpEstimateController from "./lp_estimate_controller"
application.register("lp-estimate", LpEstimateController)

import EstimateModalController from "./estimate_modal_controller"
application.register("estimate-modal", EstimateModalController)

import EstimateProgressController from "./estimate_progress_controller"
application.register("estimate-progress", EstimateProgressController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import AuctionModalController from "./auction_modal_controller"
application.register("auction-modal", AuctionModalController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import FloatingPhoneCtaController from "./floating_phone_cta_controller"
application.register("floating-phone-cta", FloatingPhoneCtaController)

import CustomerFlowTrackingController from "./customer_flow_tracking_controller"
application.register("customer-flow-tracking", CustomerFlowTrackingController)

import PurchaseResultsCarouselController from "./purchase_results_carousel_controller"
application.register("purchase-results-carousel", PurchaseResultsCarouselController)

import LocationSuggestController from "./location_suggest_controller"
application.register("location-suggest", LocationSuggestController)

import SiteMenuController from "./site_menu_controller"
application.register("site-menu", SiteMenuController)

import VehicleSuggestController from "./vehicle_suggest_controller"
application.register("vehicle-suggest", VehicleSuggestController)

import PhotoLibraryCropController from "./photo_library_crop_controller"
application.register("photo-library-crop", PhotoLibraryCropController)

import FormErrorFocusController from "./form_error_focus_controller"
application.register("form-error-focus", FormErrorFocusController)

import ContactPreferenceController from "./contact_preference_controller"
application.register("contact-preference", ContactPreferenceController)

import LiffEntryController from "./liff_entry_controller"
application.register("liff-entry", LiffEntryController)
